import { render, staticRenderFns } from "./investment-progress.vue?vue&type=template&id=0be3ca2e&scoped=true&"
import script from "./investment-progress.vue?vue&type=script&lang=js&"
export * from "./investment-progress.vue?vue&type=script&lang=js&"
import style0 from "./investment-progress.vue?vue&type=style&index=0&id=0be3ca2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3ca2e",
  null
  
)

export default component.exports